import t from "./design-system.es944.js";
import o from "./design-system.es895.js";
import { isHTMLElement as e } from "./design-system.es861.js";
import l from "./design-system.es945.js";
function c(r) {
  return r === o(r) || !e(r) ? t(r) : l(r);
}
export {
  c as default
};
//# sourceMappingURL=design-system.es908.js.map
